/** Keeps letters because the alphanumeric CNPJ is valid since July 2026. */
export const cleanCpfCnpj = (value) => String(value ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "");

export const formatCpfCnpj = (value) => {
  const document = cleanCpfCnpj(value);
  // A letter can only belong to a CNPJ; digits become a CNPJ after the 11th position.
  if (document.length <= 11 && /^\d*$/.test(document)) {
    return document
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  }
  return document.slice(0, 14)
    .replace(/^(.{2})(.)/, "$1.$2")
    .replace(/^(.{2})\.(.{3})(.)/, "$1.$2.$3")
    .replace(/^(.{2})\.(.{3})\.(.{3})(.)/, "$1.$2.$3/$4")
    .replace(/^(.{2})\.(.{3})\.(.{3})\/(.{4})(.)/, "$1.$2.$3/$4-$5");
};

const checkDigit = (values, firstWeight, lastWeight) => {
  let weight = firstWeight;
  const sum = values.reduce((total, value) => {
    const result = total + value * weight;
    weight = weight === 2 ? lastWeight : weight - 1;
    return result;
  }, 0);
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

export const isValidCpfCnpj = (value) => {
  const document = cleanCpfCnpj(value);
  if (document.length === 11) {
    if (!/^\d{11}$/.test(document) || /^(\d)\1{10}$/.test(document)) return false;
    const digits = [...document].map(Number);
    return checkDigit(digits.slice(0, 9), 10, 10) === digits[9] && checkDigit(digits.slice(0, 10), 11, 11) === digits[10];
  }
  if (!/^[A-Z0-9]{12}\d{2}$/.test(document) || /^(\d)\1{13}$/.test(document)) return false;
  const values = [...document].map((char) => char.charCodeAt(0) - 48);
  return checkDigit(values.slice(0, 12), 5, 9) === values[12] && checkDigit(values.slice(0, 13), 6, 9) === values[13];
};
